<template>
    <b-form-group>
      <label for="" v-if="field.label && field.fieldType !== 'Flag' && field.fieldType !== 'ModalComponent'">{{ field.label }} {{ req() ? '*' : '' }}</label>
        <i class="fa fa-info-circle" style="cursor: pointer"  aria-hidden="true" v-show="field.isTooltipVisible" data-toggle="tooltip" data-placement="right" :title="field.tooltipText"></i>
      <slot></slot>
      <b-form-text style="font-size: 13px; font-style: italic" v-show="field.isHelpBlockVisible" v-text="field.helpBlockText"></b-form-text>
    </b-form-group>
</template>
<script>
    export default {
        props: ['field', 'overrideRequired'],

        methods: {
            req() {
                if(this.overrideRequired !== undefined) {
                    return this.overrideRequired
                }

                return this.field.isRequired
            }
        }
    }
</script>
